/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'edit-settings': {
    width: 22,
    height: 22,
    viewBox: '0 0 22 22',
    data: '<path pid="0" d="M17.577 18.333h.046v-6.325l1.994-1.994v8.32c0 1.97-1.604 3.551-3.575 3.551H3.69c-1.971 0-3.576-1.58-3.576-3.552V5.958C.114 4.01 1.72 2.43 3.69 2.43h8.296L9.992 4.423H3.69c-.848 0-1.559.688-1.559 1.535v12.375A1.54 1.54 0 003.69 19.87h12.328c.848 0 1.559-.665 1.559-1.536zm3.85-14.964a1.5 1.5 0 01.435 1.146c0 .412-.16.825-.458 1.123l-10.29 10.289a1.588 1.588 0 01-1.03.458l-2.98.183h-.092c-.412 0-.824-.16-1.123-.459a1.636 1.636 0 01-.458-1.237l.184-2.955c.023-.39.183-.757.458-1.032L16.386.573A1.555 1.555 0 0117.51.114c.412 0 .824.184 1.122.482l2.796 2.773zM14.85 4.95l-5.156 5.133 2.223 2.223 5.156-5.133L14.85 4.95zM9.81 14.414l.664-.664-2.223-2.223-.664.664-.138 2.361 2.36-.138zM18.47 5.73l1.26-1.215-2.223-2.222-1.237 1.237 2.2 2.2z" _fill="#BEC7D4" fill-rule="evenodd"/>'
  }
})
